export default "__VITE_ASSET__B4H3YdUg__"